module.exports = __webpack_public_path__ + "img/logo-opormex.058a0588.svg";